import { render, staticRenderFns } from "./projectWarning.vue?vue&type=template&id=638e3243&scoped=true&"
import script from "./projectWarning.vue?vue&type=script&lang=js&"
export * from "./projectWarning.vue?vue&type=script&lang=js&"
import style0 from "./projectWarning.vue?vue&type=style&index=0&id=638e3243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e3243",
  null
  
)

export default component.exports